<template>
    <li class="g_faqAccordionCollapse">
        <button
            data-translate="Accordion item"
            data-of="of"
            tabindex="0"
            :aria-expanded="`${isOpen}`"
            :class="['g_title', {open: isOpen}]"
            @click="toggle()"
        >
            <slot />
            <i class="fn_caret" />
            <span v-html="feature.title" />
        </button>
        <div
            ref="collapsible"
            v-html="feature.content"
            :aria-hidden="`${!isOpen}`"
            :class="['g_wysiwyg', {open: isOpen}]"
            :style="{ height }"
        />
    </li>
</template>

<script>
import Tracking from 'nespresso-library/src/core/tracking'

export default {
    name: 'FaqAccordionCollapse',
    props: {
        feature: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            isOpen: true,
            height: '',
            realHeight: -1
        }
    },
    mounted () {
        this.$nextTick(() => {
            setTimeout(() => {
                this.getHeight()
                this.isOpen = false
                this.setHeight()
            }, 0)
        })
    },
    methods: {
        getHeight () {
            const { collapsible } = this.$refs
            this.realHeight = collapsible.offsetHeight
        },
        setHeight () {
            this.height = this.isOpen ? `${this.realHeight}px` : '0'
        },
        toggle () {
            this.isOpen = !this.isOpen
            this.setHeight()
            if (this.isOpen) {
                this.trackClickEvent()
            }
        },
        trackClickEvent () {
            const { trackingLabel, title } = this.feature
            Tracking.customEvent({
                category: 'User Engagement',
                action: 'Click',
                label: `${this.$landing.trackingLabelPrefix} - Faq - ${trackingLabel || title}`,
                interaction: 0
            })
        }
    }
}
</script>

<style lang="sass" rel="stylesheet/sass">
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import FaqAccordionCollapse
</style>
